// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__11gPS","label":"Category_label__mNkUo","content":"Category_content__27d61","header":"Category_header__9pTHG","location":"Category_location__3XLRY"};